import { metaDashBoard, metaWindows, Aditional, addLayoutToRoute } from './base_route'
const routes = [
    {
      // will match everything
      path: '/:catchAll(.*)',
      meta: Aditional,
      component: () => import('../views/InfoWindows/404.vue'),
    },
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/crm/client/active',
      redirect: '/login'
    },
    {
      path: '/crm/',
      redirect: '/login'
    },
    {
      path: '/change_password',
      name: 'Cambio de Contraseña',
      meta: metaWindows,
      component: () => import('@/views/change_password.vue'),
    },
    {
      path: '/recovery_password',
      name: 'Recuperar Contraseña',
      meta: metaWindows,
      component: () => import('@/views/recovery_password.vue'),
      props: true,
    },
    {
      path: '/login',
      name: 'Portal de Cliente',
      meta: metaWindows,
      component: () => import('@/views/login.vue'),
      props: true,
    },
    {
      path: '/aliado_comercial',
      name: 'Aliado Comercial',
      meta: metaWindows,
      component: () => import('@/views/login.vue'),
      props: true,
    },
    {
      path: '/registro_aliado',
      name: 'Registro aliado Comercial',
      meta: metaWindows,
      component: () => import('@/views/Netplus/AliadoComercial.vue'),
      props: true,
    },
    {
      path: '/401',
      name: 'ACCESO NO AUTORIZADO',
      meta: metaWindows,    
      component: () => import('@/views/InfoWindows/401.vue'),
    },
    {
      path: '/502',
      name: 'ERROR DE COMUNICACION',
      meta: metaWindows,    
      component: () => import('@/views/InfoWindows/502.vue'),
    },
    {
      path: '/403',
      name: 'TOKEN INVALIDO',
      meta: metaWindows,    
      component: () => import('@/views/InfoWindows/403.vue'),
    },
    {
      path: '/news',
      name: 'Noticias',
      meta: {
        ...Aditional,
      },
      component: () => import('@/views/news.vue'),
    },
    {
      path: '/contacts',
      name: 'Contactos',
      meta: {
        ...metaDashBoard,
        layout: 'system',
        typeRoute: ''
      },
      component: () => import('@/views/Netplus/contacts.vue'),
    },
    {
      path: '/contacts-edit',
      name: 'Contactos / ',
      meta: {
        ...metaDashBoard,
        layout: 'system',
        typeRoute: ''
      },
      component: () => import('@/views/Res_partner/edit_contact.vue'),
    },
    {
      path: '/invoices-show',
      name: 'Facturas / ',
      meta: {
        ...metaDashBoard,
        layout: 'system',
        typeRoute: ''
      },
      component: () => import('@/views/Netplus/invoices.vue'),
    },
    {
      path: '/leads',
      name: 'Prospecto',
      meta: {
        ...metaDashBoard,
        layout: 'system',
        typeRoute: ''
      },
      component: () => import('@/views/InfoWindows/401.vue'),
    },
    {
      path: '/paypal_accept',
      name: 'Aprobacion Paypal',
      meta: {
        ...metaWindows,
        methodAproval: 'Paypal'
      },
      component: () => import('@/views/Netplus/payment_return.vue'),
      props: true,
    },
    {
      path: '/biopago_accept',
      name: 'Aprobacion BioPago Online',
      meta: {
        ...metaWindows,
        methodAproval: 'Biopago'
      },
      component: () => import('@/views/Netplus/payment_return.vue'),
      props: true,
    },
    {
      path: '/login#/biopago_accept',
      redirect: '/biopago_accept'
    },
    {
      path: '/referido',
      name: 'Referido ',
      meta: {
        ...Aditional,
      },
      component: () => import('@/views/Res_partner/reference_lead.vue'),
    },
    {
      path: '/referido-create',
      name: 'Carga Prospecto',
      meta: {
        ...metaWindows,
      },
      component: () => import('@/views/crm_lead/create_lead.vue'),
    },
]
// /contacts
// /leads
const router_base =  routes.map((route) => addLayoutToRoute(route))  

export { router_base }; 